import React, { useState, useEffect } from "react";
import { useScreenSize, useCustomScreen } from "../Utils";

export default function Footer() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  return (
    <footer id="footer">
      <div className="container pt-4 pb-0">
        <div className="row me-md-auto text-center text-md-start">
          <div className="col-sm-4 col-md-6 copyright align-middle">
            <p
              style={{
                fontSize: is4kScreen
                  ? "1.8rem"
                  : isXxlScreen
                  ? "1.1rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.4rem"
                  : isLargeScreen
                  ? "1rem"
                  : "",
              }}
            >
              <strong>Customer Service Hours:</strong> Mon-Fri 8:00 am - 5:00 pm
              PST
            </p>
            <p
              style={{
                fontSize: is4kScreen
                  ? "1.8rem"
                  : isXxlScreen
                  ? "1.1rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.4rem"
                  : isLargeScreen
                  ? "1rem"
                  : "",
              }}
            >
              <strong>Phone:</strong>{" "}
              <a href="callto:+1 (805) 746-5823" className="text-white">
                +1 (805) 746-5823
              </a>
            </p>
          </div>
          <div className="col-sm-4 col-md-6 d-flex flex-column justify-content-center align-items-center align-items-md-start text-end">
            <p
              style={{
                fontSize: is4kScreen
                  ? "1.8rem"
                  : isXxlScreen
                  ? "1.1rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.4rem "
                  : isLargeScreen
                  ? "1rem"
                  : "",
              }}
            >
              <strong>Email:</strong>{" "}
              <a
                href="mailto:reports@rooftopmeasurements.com"
                className="text-white"
              >
                reports@rooftopmeasurements.com
              </a>
            </p>
            <p
              style={{
                fontSize: is4kScreen
                  ? "1.8rem"
                  : isXxlScreen
                  ? "1.1rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.4rem "
                  : isLargeScreen
                  ? "1rem"
                  : "",
              }}
            >
              <strong>
                <span>Rooftop Measurements</span>
              </strong>{" "}
              &copy; 2023 All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
